"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrokerModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const broker_controller_1 = require("./broker.controller");
const broker_service_1 = require("./broker.service");
const typeorm_1 = require("@nestjs/typeorm");
const broker_entity_1 = require("../../../../service-lib/src/lib/entities/broker.entity");
const broker_address_entity_1 = require("../../../../service-lib/src/lib/entities/broker-address.entity");
const address_module_1 = require("../address/address.module");
const contact_module_1 = require("../contact/contact.module");
const look_up_module_1 = require("../look-up/look-up.module");
const jwt_1 = require("@nestjs/jwt");
const look_up_repository_1 = require("../look-up/look-up.repository");
const entity_service_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/entity-service.utils");
const auth_guard_1 = require("../../../../auth-service/src/guards/auth.guard");
const role_guard_1 = require("../../../../auth-service/src/guards/role.guard");
const broker_repository_1 = require("./broker.repository");
const broker_contact_entity_1 = require("../../../../service-lib/src/lib/entities/broker-contact.entity");
const look_up_entity_1 = require("../../../../service-lib/src/lib/entities/look-up.entity");
const lookup_validation_1 = require("../../../../service-lib/src/lib/utils/lookup-validation");
const masters_validation_1 = require("../../../../service-lib/src/lib/utils//masters-validation");
const scope_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/scope.utils");
let BrokerModule = class BrokerModule {
};
exports.BrokerModule = BrokerModule;
exports.BrokerModule = BrokerModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [
            typeorm_1.TypeOrmModule.forFeature([broker_entity_1.Broker, broker_address_entity_1.BrokerAddress, broker_contact_entity_1.BrokerContact, look_up_entity_1.LookUp]),
            address_module_1.AddressModule,
            contact_module_1.ContactModule,
            look_up_module_1.LookUpModule,
            jwt_1.JwtModule,
        ],
        controllers: [broker_controller_1.BrokerController],
        providers: [
            broker_service_1.BrokerService,
            broker_repository_1.BrokerRepository,
            entity_service_utils_1.EntityService,
            auth_guard_1.AuthGuard,
            look_up_repository_1.LookUpRepository,
            role_guard_1.RolesGuard,
            lookup_validation_1.LookUpValidationService,
            masters_validation_1.MasterValidationService,
            scope_utils_1.ScopeService
        ],
    })
], BrokerModule);
